export class Unit {
    // tslint:disable-next-line: variable-name
    public org_id: number;
    // tslint:disable-next-line: variable-name
    public val_unit_id: string;
    // tslint:disable-next-line: variable-name
    public val_unit_desc: string;
    public created: Date;
}
